import React, { useRef, useState, useEffect, } from 'react';
import Webcam from "react-webcam";

import axios from 'axios';
import { 
  MapContainer, 
  TileLayer, 
  Marker, 
  Popup,
  useMap 
} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import {
  FaMapMarkerAlt,
  FaEye,
  FaFileExport,
  FaCalendarAlt,
  FaFilter,
  FaDownload,
  FaSearch,
  FaLocationArrow,
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaUser,
  FaChevronLeft,
  FaChevronRight,
  FaTimes
} from 'react-icons/fa';
import UserDashboard from './UserDashboard';



// Fix leaflet icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// Custom icons
const pendingIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-yellow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34]
});

const visitedIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34]
});

const completedIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34]
});

const cancelledIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34]
});

const RecenterMap = ({ center }) => {
  const map = useMap();
  useEffect(() => {
    map.setView(center);
  }, [center, map]);
  return null;
};

const MarketingDashboard = () => {
     const webcamRef = useRef(null);
  const [photo, setPhoto] = useState(null);
  const [openCamera, setOpenCamera] = useState(false);
  // States
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [mapCenter, setMapCenter] = useState([13.0827, 80.2707]); // Chennai coordinates
  const [showMapModal, setShowMapModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportDescription, setReportDescription] = useState('');
  const [submittingReport, setSubmittingReport] = useState(false);
  
  const [filters, setFilters] = useState({
    status: 'all',
    dateFrom: '',
    dateTo: '',
    search: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

const base64ToFile = (base64, filename) => {
  const arr = base64.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

  // Fetch locations on component mount
  useEffect(() => {
    fetchMyAssignments();
  }, []);

  const fetchMyAssignments = async () => {
    try {
      setLoading(true);
      setError('');
      const token = localStorage.getItem('token');
      
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      
      const response = await axios.get(
        'https://missionmap-lc.onrender.com/api/marketing-location/my-assignments', 
        {
          headers: { 
            Authorization: `Bearer ${token}` 
          }
        }
      );
      
      if (response.data.success) {
        setLocations(response.data.data);
      } else {
        setError('Failed to fetch your assignments');
      }
    } catch (err) {
      console.error('Error fetching assignments:', err);
      setError('Error loading your assigned locations');
    } finally {
      setLoading(false);
    }
  };

  // Filter locations based on filters
  const filteredLocations = locations.filter(location => {
    const matchesStatus = filters.status === 'all' || location.status === filters.status;
    const matchesSearch = !filters.search || 
      location.address.toLowerCase().includes(filters.search.toLowerCase()) ||
      location.description.toLowerCase().includes(filters.search.toLowerCase()) ||
      location.assignedToName.toLowerCase().includes(filters.search.toLowerCase());
    
    let matchesDate = true;
    if (filters.dateFrom) {
      const locationDate = new Date(location.createdAt);
      const fromDate = new Date(filters.dateFrom);
      matchesDate = locationDate >= fromDate;
    }
    if (filters.dateTo && matchesDate) {
      const locationDate = new Date(location.createdAt);
      const toDate = new Date(filters.dateTo);
      toDate.setHours(23, 59, 59, 999);
      matchesDate = locationDate <= toDate;
    }
    
    return matchesStatus && matchesSearch && matchesDate;
  });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredLocations.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredLocations.length / itemsPerPage);

  const handlePaginate = (pageNumber) => setCurrentPage(pageNumber);

  // Handle View on Map click
  const handleViewOnMap = (location) => {
    setSelectedLocation(location);
    setMapCenter([location.latitude, location.longitude]);
    setShowMapModal(true);
  };

  // Handle Report click
  const handleReportClick = (location) => {
    setSelectedLocation(location);
    setReportDescription('');
    setShowReportModal(true);
  };

  const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject('Geolocation not supported');
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        });
      },
      (error) => {
        reject(error.message);
      },
      { enableHighAccuracy: true }
    );
  });
};

const handleSubmitReport = async () => {
  if (!reportDescription.trim()) {
    alert('Please enter report description');
    return;
  }

  if (!photo) {
    alert('Please capture photo');
    return;
  }

  try {
    setSubmittingReport(true);
    const token = localStorage.getItem('token');

    const { latitude, longitude } = await getCurrentLocation();

    const imageFile = base64ToFile(photo, "report.jpg");

    const formData = new FormData();
    formData.append("reportDescription", reportDescription);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
    formData.append("photo", imageFile);

    await axios.post(
      `https://missionmap-lc.onrender.com/api/marketing-report/submit/${selectedLocation._id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // ✅ VERY IMPORTANT — update UI immediately
    setLocations(prev =>
      prev.map(loc =>
        loc._id === selectedLocation._id
          ? { ...loc, status: 'completed' }
          : loc
      )
    );

    alert('Report submitted successfully ✅');

    setShowReportModal(false);
    setReportDescription('');
    setPhoto(null);

  } catch (error) {
    console.error(error);
    alert('Error submitting report ❌, Turn the Location ON and try again');
  } finally {
    setSubmittingReport(false);
  }
};

  // Status badge component
  const StatusBadge = ({ status }) => {
    const config = {
      pending: { color: 'bg-yellow-100 text-yellow-800', icon: <FaClock className="mr-1" /> },
      visited: { color: 'bg-blue-100 text-blue-800', icon: <FaLocationArrow className="mr-1" /> },
      completed: { color: 'bg-green-100 text-green-800', icon: <FaCheckCircle className="mr-1" /> },
      cancelled: { color: 'bg-red-100 text-red-800', icon: <FaTimesCircle className="mr-1" /> }
    };

    const { color, icon } = config[status] || config.pending;

    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${color}`}>
        {icon}
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </span>
    );
  };

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Get current user email from localStorage
  const getCurrentUserEmail = () => {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    return userData.email || '';
  };

  // Export data as CSV
  const handleExportData = () => {
    
    const headers = ['Date', 'Time', 'Address', 'Description', 'Assigned To', 'Email', 'Status', 'Latitude', 'Longitude'];
    const csvData = filteredLocations.map(loc => [
      formatDate(loc.createdAt),
      formatTime(loc.createdAt),
      `"${loc.address}"`,
      `"${loc.description}"`,
      loc.assignedToName,
      loc.assignedToEmail,
      loc.status,
      loc.latitude,
      loc.longitude
    ]);
    
    const csv = [headers, ...csvData].map(row => row.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `marketing_assignments_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <UserDashboard />
      
      {/* Main Container */}
      <div className="p-4 md:p-6 max-w-10xl mx-auto">
        {/* Header */}
        <div className="mb-8 mt-12">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 flex items-center gap-3">
            <FaMapMarkerAlt className="text-blue-600" />
            Marketing Assignments
          </h1>
          <p className="text-gray-600 mt-1 md:mt-2 text-sm md:text-base">View and manage locations assigned specifically to you</p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-6 md:mb-8">
          <div className="bg-white rounded-lg md:rounded-xl shadow p-3 md:p-5">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs md:text-sm text-gray-500">My Total</p>
                <p className="text-xl md:text-3xl font-bold text-gray-800 mt-1">{locations.length}</p>
              </div>
              <div className="bg-blue-100 p-2 md:p-3 rounded-lg">
                <FaMapMarkerAlt className="text-blue-600 text-base md:text-xl" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg md:rounded-xl shadow p-3 md:p-5">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs md:text-sm text-gray-500">Pending</p>
                <p className="text-xl md:text-3xl font-bold text-yellow-600 mt-1">
                  {locations.filter(l => l.status === 'pending').length}
                </p>
              </div>
              <div className="bg-yellow-100 p-2 md:p-3 rounded-lg">
                <FaClock className="text-yellow-600 text-base md:text-xl" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg md:rounded-xl shadow p-3 md:p-5">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs md:text-sm text-gray-500">Visited</p>
                <p className="text-xl md:text-3xl font-bold text-blue-600 mt-1">
                  {locations.filter(l => l.status === 'visited').length}
                </p>
              </div>
              <div className="bg-blue-100 p-2 md:p-3 rounded-lg">
                <FaLocationArrow className="text-blue-600 text-base md:text-xl" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg md:rounded-xl shadow p-3 md:p-5">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs md:text-sm text-gray-500">Completed</p>
                <p className="text-xl md:text-3xl font-bold text-green-600 mt-1">
                  {locations.filter(l => l.status === 'completed').length}
                </p>
              </div>
              <div className="bg-green-100 p-2 md:p-3 rounded-lg">
                <FaCheckCircle className="text-green-600 text-base md:text-xl" />
              </div>
            </div>
          </div>
        </div>

        {/* Filters Section */}
        <div className="bg-white rounded-lg md:rounded-xl shadow p-4 md:p-5 mb-4 md:mb-6">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <FaSearch className="text-gray-400" />
                </div>
                <input
                  type="text"
                  placeholder="Search address, description..."
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  value={filters.search}
                  onChange={(e) => {
                    setFilters({...filters, search: e.target.value});
                    setCurrentPage(1);
                  }}
                />
              </div>
            </div>
            
            <div className="flex flex-wrap gap-2 md:gap-3">
              <select
                className="w-full md:w-auto border border-gray-300 rounded-lg px-3 md:px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                value={filters.status}
                onChange={(e) => {
                  setFilters({...filters, status: e.target.value});
                  setCurrentPage(1);
                }}
              >
                <option value="all">All Status</option>
                <option value="pending">Pending</option>
                <option value="visited">Visited</option>
                <option value="completed">Completed</option>
                <option value="cancelled">Cancelled</option>
              </select>

              <div className="flex items-center gap-2 flex-1 md:flex-none">
                <FaCalendarAlt className="text-gray-400 hidden md:block" />
                <input
                  type="date"
                  className="flex-1 border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  value={filters.dateFrom}
                  onChange={(e) => {
                    setFilters({...filters, dateFrom: e.target.value});
                    setCurrentPage(1);
                  }}
                />
              </div>

              <button
                onClick={() => {
                  setFilters({ status: 'all', dateFrom: '', dateTo: '', search: '' });
                  setCurrentPage(1);
                }}
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm md:text-base"
              >
                Clear
              </button>

              <button
                onClick={handleExportData}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2 text-sm md:text-base"
              >
                <FaDownload />
                <span className="hidden md:inline">Export</span>
              </button>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="bg-white rounded-lg md:rounded-xl shadow overflow-hidden">
          <div className="px-4 md:px-6 py-3 md:py-4 border-b border-gray-200">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
              <div>
                <h2 className="text-lg md:text-xl font-semibold text-gray-800">My Assigned Locations</h2>
                <p className="text-gray-600 text-xs md:text-sm mt-1">
                  Showing {currentItems.length} of {filteredLocations.length} locations
                </p>
              </div>
              <div className="text-sm text-gray-500">
                Page {currentPage} of {totalPages}
              </div>
            </div>
          </div>

          {loading ? (
            <div className="p-8 text-center">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <p className="text-gray-600 mt-2">Loading your assignments...</p>
            </div>
          ) : error ? (
            <div className="p-8 text-center text-red-600">
              <p>{error}</p>
              <button 
                onClick={fetchMyAssignments}
                className="mt-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                Retry
              </button>
            </div>
          ) : filteredLocations.length === 0 ? (
            <div className="p-8 text-center">
              <FaMapMarkerAlt className="mx-auto text-gray-400 text-4xl" />
              <p className="text-gray-600 mt-2">No locations found</p>
            </div>
          ) : (
            <div className="max-h-[500px] overflow-y-auto  overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50 sticky top-0 z-10">
                  <tr>
                    <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Date & Time
                    </th>
                    <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Address
                    </th>
                    <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Description
                    </th>
                    <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Assigned To
                    </th>
                    <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {currentItems.map((location) => {
                    const currentUserEmail = getCurrentUserEmail();
                    const isAssignedToMe = location.assignedToEmail === currentUserEmail;
                    
                    return (
                      <tr key={location._id} className="hover:bg-gray-50">
                        <td className="px-4 md:px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900 font-medium">
                            {formatDate(location.createdAt)}
                          </div>
                          <div className="text-sm text-gray-500">
                            {formatTime(location.createdAt)}
                          </div>
                        </td>
                        <td className="px-4 md:px-6 py-4">
                          <div className="text-sm text-gray-900 max-w-[200px] md:max-w-xs truncate" title={location.address}>
                            {location.address}
                          </div>
                        </td>
                        <td className="px-4 md:px-6 py-4">
                          <div className="text-sm text-gray-900 max-w-[200px] md:max-w-xs truncate" title={location.description}>
                            {location.description}
                          </div>
                        </td>
                        <td className="px-4 md:px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="flex-shrink-0 h-8 w-8 bg-blue-100 rounded-full flex items-center justify-center">
                              <FaUser className="text-blue-600 text-sm" />
                            </div>
                            <div className="ml-3">
                              <div className="text-sm font-medium text-gray-900 flex items-center">
                                <span className="truncate max-w-[100px] md:max-w-none">{location.assignedToName}</span>
                                {isAssignedToMe && (
                                  <span className="ml-2 px-2 py-0.5 bg-green-100 text-green-800 text-xs rounded-full flex-shrink-0">
                                    You
                                  </span>
                                )}
                              </div>
                              <div className="text-xs text-gray-500 truncate max-w-[120px] md:max-w-none">
                                {location.assignedToEmail}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-4 md:px-6 py-4 whitespace-nowrap">
                          <StatusBadge status={location.status} />
                        </td>
                        <td className="px-4 md:px-6 py-4 whitespace-nowrap text-sm font-medium">
                          <div className="flex flex-col md:flex-row gap-2">
                            <button
                              onClick={() => handleViewOnMap(location)}
                              className="inline-flex items-center justify-center px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-xs md:text-sm"
                            >
                              <FaEye className="mr-1" />
                              Map
                            </button>
                            <button
                              onClick={() => handleReportClick(location)}
                             
                              className="inline-flex items-center justify-center px-3 py-1.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-xs md:text-sm"
                            >
                              <FaFileExport className="mr-1" />
                              Report
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination */}
          {filteredLocations.length > 0 && totalPages > 1 && (
            <div className="px-4 md:px-6 py-3 md:py-4 border-t border-gray-200">
              <div className="flex flex-col md:flex-row items-center justify-between gap-3">
                <div className="text-sm text-gray-700">
                  Showing <span className="font-medium">{indexOfFirstItem + 1}</span> to{' '}
                  <span className="font-medium">
                    {Math.min(indexOfLastItem, filteredLocations.length)}
                  </span>{' '}
                  of <span className="font-medium">{filteredLocations.length}</span> results
                </div>
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => handlePaginate(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-3 py-1 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                  >
                    <FaChevronLeft className="text-xs" />
                    <span className="ml-1">Prev</span>
                  </button>
                  
                  <div className="flex space-x-1">
                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                      .filter(page => {
                        // Show first, last, current, and adjacent pages
                        return page === 1 || 
                               page === totalPages || 
                               (page >= currentPage - 1 && page <= currentPage + 1);
                      })
                      .map((page, index, array) => {
                        // Add ellipsis for gaps
                        const prevPage = array[index - 1];
                        if (prevPage && page > prevPage + 1) {
                          return (
                            <React.Fragment key={`ellipsis-${page}`}>
                              <span className="px-3 py-1">...</span>
                              <button
                                onClick={() => handlePaginate(page)}
                                className={`px-3 py-1 rounded-md text-sm ${
                                  currentPage === page
                                    ? 'bg-blue-600 text-white'
                                    : 'border border-gray-300 hover:bg-gray-50'
                                }`}
                              >
                                {page}
                              </button>
                            </React.Fragment>
                          );
                        }
                        
                        return (
                          <button
                            key={page}
                            onClick={() => handlePaginate(page)}
                            className={`px-3 py-1 rounded-md text-sm ${
                              currentPage === page
                                ? 'bg-blue-600 text-white'
                                : 'border border-gray-300 hover:bg-gray-50'
                            }`}
                          >
                            {page}
                          </button>
                        );
                      })}
                  </div>
                  
                  <button
                    onClick={() => handlePaginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-3 py-1 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                  >
                    <span className="mr-1">Next</span>
                    <FaChevronRight className="text-xs" />
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Map Modal */}
      {showMapModal && selectedLocation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
            <div className="flex items-center justify-between p-4 md:p-6 border-b">
              <h3 className="text-lg md:text-xl font-semibold text-gray-800 flex items-center gap-2">
                <FaMapMarkerAlt className="text-blue-600" />
                Location Map View
              </h3>
              <button
                onClick={() => setShowMapModal(false)}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                <FaTimes />
              </button>
            </div>
            <div className="flex-1 overflow-auto p-4">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
                <div className="lg:col-span-2">
                  <div className="h-[400px] md:h-[500px] rounded-lg overflow-hidden">
                    <MapContainer
                      center={mapCenter}
                      zoom={15}
                      className="h-full w-full"
                    >
                      <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      />
                      <RecenterMap center={mapCenter} />
                      <Marker
                        position={[selectedLocation.latitude, selectedLocation.longitude]}
                        icon={
                          selectedLocation.status === 'completed' ? completedIcon :
                          selectedLocation.status === 'visited' ? visitedIcon :
                          selectedLocation.status === 'cancelled' ? cancelledIcon :
                          pendingIcon
                        }
                      >
                        <Popup>
                          <div className="font-semibold">{selectedLocation.address}</div>
                          <div className="text-sm mt-1">{selectedLocation.description}</div>
                          <div className="text-xs text-gray-500 mt-2">
                            Assigned to: {selectedLocation.assignedToName}
                          </div>
                        </Popup>
                      </Marker>
                    </MapContainer>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-3">Location Details</h4>
                    <div className="space-y-3">
                      <div>
                        <label className="text-sm text-gray-500">Address</label>
                        <p className="text-gray-800 break-words">{selectedLocation.address}</p>
                      </div>
                      <div>
                        <label className="text-sm text-gray-500">Description</label>
                        <p className="text-gray-800 break-words">{selectedLocation.description}</p>
                      </div>
                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <label className="text-sm text-gray-500">Latitude</label>
                          <p className="text-gray-800 font-mono">{selectedLocation.latitude.toFixed(6)}</p>
                        </div>
                        <div>
                          <label className="text-sm text-gray-500">Longitude</label>
                          <p className="text-gray-800 font-mono">{selectedLocation.longitude.toFixed(6)}</p>
                        </div>
                      </div>
                      <div>
                        <label className="text-sm text-gray-500">Assigned To</label>
                        <p className="text-gray-800">{selectedLocation.assignedToName}</p>
                        <p className="text-sm text-gray-500">{selectedLocation.assignedToEmail}</p>
                      </div>
                      <div>
                        <label className="text-sm text-gray-500">Status</label>
                        <div className="mt-1">
                          <StatusBadge status={selectedLocation.status} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-blue-50 rounded-lg p-4">
                    <h4 className="font-semibold text-blue-800 mb-2">Quick Actions</h4>
                    <div className="space-y-2">
                      <button
                        onClick={() => {
                          setShowMapModal(false);
                          handleReportClick(selectedLocation);
                        }}
                        
                        className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors text-sm md:text-base"
                      >
                        <FaFileExport className="inline mr-2" />
                        Submit Report
                      </button>
                      <button
                        onClick={() => {
                          const url = `https://www.google.com/maps?q=${selectedLocation.latitude},${selectedLocation.longitude}`;
                          window.open(url, '_blank');
                        }}
                        className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors text-sm md:text-base"
                      >
                        <FaMapMarkerAlt className="inline mr-2" />
                        Open in Google Maps
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4 md:p-6 border-t">
              <button
                onClick={() => setShowMapModal(false)}
                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Report Modal */}
      {showReportModal && selectedLocation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-hidden flex flex-col">
            <div className="flex items-center justify-between p-4 md:p-6 border-b">
              <h3 className="text-lg md:text-xl font-semibold text-gray-800 flex items-center gap-2">
                <FaFileExport className="text-green-600" />
                Submit Visit Report
              </h3>
              <button
                onClick={() => setShowReportModal(false)}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                <FaTimes />
              </button>
            </div>
            <div className="flex-1 overflow-auto p-4 md:p-6">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Location Address
                </label>
                <p className="bg-gray-50 p-3 rounded-lg text-gray-800 break-words">
                  {selectedLocation.address}
                </p>
              </div>
              
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Report Description <span className="text-red-500">*</span>
                </label>
                <textarea
                  value={reportDescription}
                  onChange={(e) => setReportDescription(e.target.value)}
                  rows={5}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm md:text-base"
                  placeholder="Enter details about the visit, observations, leads collected, etc..."
                />
                <p className="text-sm text-gray-500 mt-1">
                  Please provide detailed information about your marketing visit
                </p>
              </div>

              {/* Camera Section */}
<div className="mb-6">
  <label className="block text-sm font-medium text-gray-700 mb-2">
    Capture Location Photo <span className="text-red-500">*</span>
  </label>

  {!openCamera && !photo && (
    <button
      onClick={() => setOpenCamera(true)}
      className="px-4 py-2 bg-blue-600 text-white rounded-lg"
    >
      Open Camera
    </button>
  )}

  {openCamera && (
    <div className="space-y-3">
      <Webcam
  audio={false}
  ref={webcamRef}
  screenshotFormat="image/jpeg"
  videoConstraints={{
    facingMode: "environment"   // ❌ remove { exact }
  }}
  onUserMediaError={(err) => {
    console.log("Camera error:", err);
    alert("Camera access failed. Please allow camera permission.");
  }}
  className="w-full rounded-lg"
/>


      <button
        onClick={() => {
          const imageSrc = webcamRef.current.getScreenshot();
          setPhoto(imageSrc);
          setOpenCamera(false);
        }}
        className="px-4 py-2 bg-green-600 text-white rounded-lg"
      >
        Capture Photo
      </button>
    </div>
  )}

  {photo && (
    <div className="space-y-3">
      <img src={photo} alt="Captured" className="rounded-lg" />
      <button
        onClick={() => {
          setPhoto(null);
          setOpenCamera(true);
        }}
        className="px-4 py-2 bg-yellow-500 text-white rounded-lg"
      >
        Retake
      </button>
    </div>
  )}
</div>

            </div>
            <div className="p-4 md:p-6 border-t flex justify-end space-x-3">
              <button
                onClick={() => setShowReportModal(false)}
                className="px-4 md:px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors text-sm md:text-base"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmitReport}
                disabled={submittingReport || !reportDescription.trim()}
                className="px-4 md:px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm md:text-base"
              >
                {submittingReport ? (
                  <>
                    <div className="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Submitting...
                  </>
                ) : (
                  'Submit Report'
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MarketingDashboard;